export const AVAILABLE_COLORS = [
  // Neutrals – Whites, Grays, Blacks & other neutrals:
  { name: "White", hex: "#ffffff" }, // white
  { name: "Off-white", hex: "#e5e5e5" }, // gray-200
  { name: "Light Gray", hex: "#d5d5d5" }, // gray-300
  { name: "Gray", hex: "#737373" }, // gray-500
  { name: "Dark Gray", hex: "#404040" }, // gray-700
  { name: "Black", hex: "#171717" }, // neutral-900
  { name: "Beige", hex: "#DDC9BC" }, // stone-200
  { name: "Camel-colored", hex: "#9B7540" },
  { name: "Cream-colored", hex: "#F1E5CC" },
  { name: "Brown", hex: "#92400e" }, // amber-800
  { name: "Dark brown", hex: "#422006" }, // yellow-950

  // Red group
  { name: "Red", hex: "#ef4444" }, // red-500
  { name: "Rust red", hex: "#A74818" },
  { name: "Burgundy", hex: "#be123c" }, // rose-700
  { name: "Light pink", hex: "#fecdd3" }, // rose-200
  { name: "Pink", hex: "#ec4899" }, // pink-500
  // Orange
  { name: "Orange", hex: "#f97316" }, // orange-500
  // Yellow
  { name: "Yellow", hex: "#eab308" }, // yellow-500
  // Green group
  { name: "Green", hex: "#22c55e" }, // green-500
  { name: "Olive green", hex: "#61682F" },
  { name: "Dark green", hex: "#052e16" }, // green-800
  { name: "Sage green", hex: "#828D72" },
  { name: "Teal", hex: "#14b8a6" }, // teal-500
  // Blue group
  { name: "Light blue", hex: "#93c5fd" }, // blue-300
  { name: "Blue", hex: "#3b82f6" }, // blue-500
  { name: "Navy", hex: "#1e40af" }, // blue-800
  // Purple group
  { name: "Purple", hex: "#a855f7" }, // purple-500
];
